<template>
    <div @click="visible = false">
        <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="operate"
            :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs"
            @addCreateRule="showAddCreateRulePopup = true; contactName = ''; selectAgentId = ''; isEditId = ''"
            pageName="contacts" ref="table" @isPageSmall="isPageSmall"></common-table>
        <el-drawer :visible.sync="showAddCreateRulePopup" :size="pageSmall ? '100%' : '50%'" direction="rtl"
            :withHeader="false">
            <div class="addCreateRuleBox ">
                <div class="createRuleTitle flex-between alcenter">
                    新建联系人
                    <i class="el-icon-close"
                        @click="showAddCreateRulePopup = false; contactName = ''; selectAgentId = ''; isEditId = ''"></i>
                </div>
                <div class="setRuleContent">
                    <div class="oe-drawer-guide">
                        <guide-panel
                            dense
                            title="联系人说明"
                            summary="这张表单用于新增接收系统通知的人。保存后，余额预警、预算提醒、亏损关停、智能调控、智能重建等规则都可以直接选择这个联系人。"
                            tone="success"
                            icon="el-icon-user-solid"
                            :points="[
                                '联系人名称建议写成“岗位 + 姓名”，方便后续在规则里快速识别。',
                                '当前页面维护的是通知接收人，不是广告账户。',
                                '新增后通常还需要继续完成微信绑定，才能真正收到消息。'
                            ]"
                        />
                    </div>
                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">联系人名称</span>
                        <el-input class="input250 w300 " v-model="contactName" placeholder="请输入联系人名称" />
                    </div>
                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">请选择代理</span>
                        <el-select size="medium" v-model="selectAgentId" placeholder="请选择代理" clearable filterable>
                            <el-option v-for="(option, index) in agentList" :key="index" :label="option.username"
                                :value="option.id" />
                        </el-select>
                    </div>
                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">通知方式</span>
                        <div class="noticeBox ">
                            微信通知
                        </div>
                    </div>


                </div>
                <div class="drawer_footer flex-end alcenter">
                    <el-button class="mb-10 fs18" round type="primary" size="small"
                        @click="showAddCreateRulePopup = false; contactName = ''; selectAgentId = ''; isEditId = ''">
                        取消
                    </el-button>
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="addCreateRule">
                        确定
                    </el-button>
                </div>
            </div>
        </el-drawer>
        <el-dialog title="绑定微信" :visible.sync="dialogVisible" width="30%">
            <span class=" text-center">点击绑定微信</span>
            <div class=" text-center pt30">
                <img class="qrcodeImg" :src="qrcodeImg" alt="">
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import GuidePanel from "@/components/GuidePanel/GuidePanel";

export default {
    name: 'contacts',
    components: { CommonTable, GuidePanel },
    data() {
        return {
            contactName: '',
            isEditId: false,
            visible: false,
            qrcodeImg: '',
            selectAgentId: '',
            agentList: [],
            showAddCreateRulePopup: false,
            dialogVisible: false,
            searchs: [{
                name: 'advertiserId',
                placeholder: '请输入联系人名称搜索',
                type: 'input',
                input: true,
                selectData: [],
                width: true
            }],
            permission: {
                add: 'launchTheProduct:add',
                update: 'launchTheProduct:update',
                delete: 'launchTheProduct:delete',
                deleteBatch: 'launchTheProduct:deleteBatch'
            },
            url: {
                get: '/wechatUser/listByCondition',
                // add: '/launchTheProduct/add',
                // update: '/launchTheProduct/update',
                // delete: '/launchTheProduct/delete',
                // delete_batch: '/launchTheProduct/deleteBatch',
                // status: '/launchTheProduct/status',
            },
            tableColumns: [{
                field: 'wechatName',  // 字段名
                label: '联系人',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            },
            {
                field: 'openId',  // 字段名
                label: '微信名',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            },
            {
                field: 'createTime',  // 字段名
                label: '创建时间',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'createPerson',  // 字段名
                label: '创建人',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }],
            formFields: {
                addTitle: '添加',
                updateTitle: '修改',
                model: [
                    {
                        field: 'id',  // 字段名
                        label: 'ID',  // 字段显示名称
                        type: 'input',
                        add: false,  // 是否添加
                        update: true
                    },
                    {
                        field: 'agentId',  // 字段名
                        label: 'agentId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入agentId',
                        rules: [
                            { required: true, message: 'agentId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'userId',  // 字段名
                        label: 'userId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入userId',
                        rules: [
                            { required: true, message: 'userId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'advertiserId',  // 字段名
                        label: 'advertiserId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入advertiserId',
                        rules: [
                            { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'aweMeId',  // 字段名
                        label: 'aweMeId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入aweMeId',
                        rules: [
                            { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productId',  // 字段名
                        label: 'productId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productId',
                        rules: [
                            { required: true, message: 'productId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productName',  // 字段名
                        label: 'productName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productName',
                        rules: [
                            { required: true, message: 'productName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'img',  // 字段名
                        label: 'img',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入img',
                        rules: [
                            { required: true, message: 'img不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'tag',  // 字段名
                        label: 'tag',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入tag',
                        rules: [
                            { required: true, message: 'tag不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'categoryName',  // 字段名
                        label: 'categoryName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入categoryName',
                        rules: [
                            { required: true, message: 'categoryName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'sellNum',  // 字段名
                        label: 'sellNum',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入sellNum',
                        rules: [
                            { required: true, message: 'sellNum不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'grayReason',  // 字段名
                        label: 'grayReason',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入grayReason',
                        rules: [
                            { required: true, message: 'grayReason不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'squareImageList',  // 字段名
                        label: 'squareImageList',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入squareImageList',
                        rules: [
                            { required: true, message: 'squareImageList不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelId',  // 字段名
                        label: 'channelId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelId',
                        rules: [
                            { required: true, message: 'channelId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelType',  // 字段名
                        label: 'channelType',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelType',
                        rules: [
                            { required: true, message: 'channelType不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    },
                ]
            },
            operate: [{
                icon: 'el-icon-edit',
                type: 'text',
                text: '编辑',
                handle: (row) => {
                    console.log(row)
                    this.isEditId = row.id
                    this.showAddCreateRulePopup = true
                    this.contactName = ''
                    this.selectAgentId = ''
                    this.isEditId = ''
                    this.contactName = row.wechatName
                    console.log(this.agentList, 'agentList')
                    let index = this.agentList.findIndex((obj) => obj.id == row.agentId)
                    console.log(index, 'index')
                    if (index !== -1) {
                        this.selectAgentId = row.agentId
                    }


                },
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '删除',
                handle: (row) => {
                    console.log(row)
                    this.$axios.post({
                        url: '/wechatUser/delete/' + row.id,
                        success: (res) => {
                            this.loading = false
                            console.log('333', res)
                            if (res.code == 0) {
                                this.$message.success('删除成功')
                                this.$refs.table.getData()

                            } else {
                                this.$message.error(res.msg || '出错了')

                            }

                        },
                        error: () => {
                            this.loading = false
                            this.$message.error('出错了')
                        },
                    })
                    // this.resetPwdForm.id = row.id;
                    // this.resetPwdForm.username = row.username;
                    // this.resetPwdVisible = true;
                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '绑定微信',
                bindWx: true,
                handle: (row) => {
                    console.log(row)
                    this.getQRCode(row.agentId, row.wechatName)
                    this.dialogVisible = true
                    // this.resetPwdForm.id = row.id;
                    // this.resetPwdForm.username = row.username;
                    // this.resetPwdVisible = true;
                }
            }],
            buttons: [
                {

                }
            ],
            pageSmall: false
        }
    },
    mounted() {
        // window.addEventListener('scroll', this.handleScroll);
        // 初始化抖音账号列表为空
        this.getAgentList()
    },

    beforeDestroy() {
        // window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        dialogVisible() {
            if (!this.dialogVisible) {
                this.$refs.table.getData()
            }
        }
    },
    methods: {
        isPageSmall(data) {
            this.pageSmall = data;
            console.log(this.pageSmall)
        },
        getAgentList() {
            this.$axios.post({
                url: '/agent/getAll',
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.agentList = res.data
                        console.log('333', this.agentList)

                    } else {
                        this.$message.error(res.msg || '出错了')

                    }
                    //          
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },

        getQRCode(agentId, wechatName) {
            // this.visible = true
            this.$axios.get({
                url: '/wechatUser/getQrCode/' + agentId + '_' + wechatName,
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.qrcodeImg = res.data
                        this.visible = true
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }
                    //          
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },

        addCreateRule() {
            if (!this.contactName) {
                this.$message.error('请输入联系人名称')
                return
            }
            if (!this.selectAgentId) {
                this.$message.error('请选择代理')
                return
            }
            if (this.isEditId) {
                this.$axios.post({
                    url: '/wechatUser/update',
                    data: {
                        agentId: this.selectAgentId,
                        wechatName: this.contactName,
                        id: this.isEditId
                    },
                    success: (res) => {
                        this.loading = false
                        console.log('333', res)
                        if (res.code == 0) {
                            this.showAddCreateRulePopup = false;
                            this.contactName = ''
                            this.selectAgentId = ''
                            this.isEditId = ''
                            this.$message.success('修改成功')
                            this.$refs.table.getData()

                        } else {
                            this.$message.error(res.msg || '出错了')
                        }
                    },
                    error: () => {
                        this.$message.error('出错了')
                    },
                })
            } else {
                this.$axios.post({
                    url: '/wechatUser/add',
                    data: {
                        agentId: this.selectAgentId,
                        wechatName: this.contactName
                    },
                    success: (res) => {
                        this.loading = false
                        console.log('333', res)
                        if (res.code == 0) {
                            this.showAddCreateRulePopup = false;
                            this.contactName = ''
                            this.selectAgentId = ''
                            this.isEditId = ''
                            this.$message.success('添加成功')
                            this.$refs.table.getData()

                        } else {
                            this.$message.error(res.msg || '出错了')

                        }
                        //          
                    },
                    error: () => {
                        this.loading = false
                        this.$message.error('出错了')
                    },
                })
            }




        },
    }
}
</script>

<style scoped>
@import "../../styles/ocean-engine-rule-drawer.css";

.createRuleTitle {
    font-weight: 600;
}

.createRuleTitle i {
    cursor: pointer;
}

.drawer_footer {
    position: static;
}

.qrcodeImg {
    height: 300px;
    width: 300px;
}


/deep/ .selectContentBox .el-checkbox__inner {
    margin-bottom: 15px !important;
}

/deep/ .input100 .el-input__inner {
    width: 100px;
}

/deep/ .input150 .el-input__inner {
    width: 150px;
}

/deep/ .input200 .el-input__inner {
    width: 200px;
}
</style>
